import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
/// <reference path="<relevant path>/node_modules/@types/googlemaps/index.d.ts" />

@Component({
  selector: 'app-autocompletar',
  templateUrl: './autocompletar.component.html',
  styleUrls: ['./autocompletar.component.scss']
})
export class AutocompletarComponent implements AfterViewInit {
  @Input() tipoDireccion: string;
  @Output() setDireccion: EventEmitter<any> = new EventEmitter();
  @ViewChild('textoDireccion', { static: false}) textoDireccion: ElementRef;

  direccionCompleta: string;
  cargandoDirecciones: boolean;

  constructor() { }

  ngAfterViewInit() {
    this.obtenerLugarAutoCompletar();
  }

  private obtenerLugarAutoCompletar() {
    const autocompletar = new google.maps.places.Autocomplete(this.textoDireccion.nativeElement, {
      componentRestrictions: { country: 'CL'},
      types: ['address']
    });
    google.maps.event.addListener(autocompletar, 'place_changed', () => {
      const lugar = autocompletar.getPlace();
      this.enviarEvento(lugar);
    });
  }

  enviarEvento(lugar: Object) {
    this.setDireccion.emit(lugar);
  }

}
